module.exports = __webpack_public_path__ + "images/onthemoveab8c77e64f915c806175faf30af2ae4b.png";